<template>
  <Watermark
    v-if="loggedIn && hasRole('ui', 'UI_ENABLED_WATERMARK') && text"
    :text="text"
  />
</template>

<script>
import { mapState } from 'vuex'
import { hasRole } from 'utils/functions'
import moment from 'libs/moment'

export default {
  name: 'CorpWatermark',
  computed: {
    ...mapState({
      loggedIn: ({ session }) => session.status.loggedIn,
      user: ({ session }) => session.user
    }),

    text () {
      if (!hasRole('ui', 'UI_ENABLED_WATERMARK')) return null

      const { email = '', legacyUserId = '' } = this.user.business
      const date = moment().format('YYYY-MM-DD')
      return `${legacyUserId} ${email} ${date}`
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    }
  }
}
</script>
